import * as React from 'react';

import {Button} from 'shells/button/button';
import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';

const BULLETS = [
    'Automatically send leads to Constant Contact based on your sales pipeline.',
    'Sync your contacts between Nutshell and Constant Contact. Make sure everything is up to date everywhere you need it.',
];

type Props = {
    onConstantContactConnect: () => Promise<any>;
};

type State = {
    isConnecting: boolean;
};

export class ConstantContactCTA extends React.PureComponent<Props, State> {
    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            isConnecting: false,
        };
    }

    render() {
        return (
            <EmptyStateLarge
                title='Connect your Constant Contact account with Nutshell'
                cta={
                    <Button
                        variant='primary'
                        size='xlarge'
                        onClick={this.handleConnectConstantContact}
                    >
                        {this.state.isConnecting
                            ? 'Connecting…'
                            : 'Connect your Constant Contact account'}
                    </Button>
                }
                // @ts-expect-error
                variant='left'
                icon={
                    <img
                        style={{width: 300}}
                        src='/include/images/email-marketing/constant-contact-graphic-2.png'
                    />
                }
                detailTextBullets={BULLETS}
            />
        );
    }

    handleConnectConstantContact = () => {
        this.setState({isConnecting: true});
        this.props.onConstantContactConnect().then(() => {
            this.setState({isConnecting: false});
        });
    };
}
